import styled from 'styled-components'
import {Typography} from '@mui/material'

export const SectionContainer = styled.div<{ editMode?: boolean }>`
    position: relative;
    border: 1px solid transparent;
    border-radius: 8px;
    transition: border-color 0.2s ease;
    ${props => props.editMode && `
    border-color: #e0e0e0;
    padding: 8px;
  `}
`

export const HiddenSectionContainer = styled.div`
    padding: 16px;
    background-color: #f5f5f5;
    border-radius: 8px;
    border: 1px dashed #ccc;
`

export const HiddenSectionTitle = styled(Typography)`
    color: #666;
    font-style: italic;
`